import { configureStore } from '@reduxjs/toolkit';
import counterReducer from './counterSlice';
import onlineUsersReducer from './onlineUsersSlice';
import lobbyReducer from './lobbySlice';
import inviteReducer from './inviteSlice';
import profileReducer from './profileSlice';
import gameReducer from './gameSlice';
import gameSummaryReducer from './gameSummarySlice';
import gameSessionReducer from './gameSessionSlice';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    onlineUsers: onlineUsersReducer,
    lobby: lobbyReducer,
    invite: inviteReducer,
    profile: profileReducer,
    game: gameReducer,
    gameSummary: gameSummaryReducer,
    gameSession: gameSessionReducer
  },
});

// Infer state and dispatch types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
